import {Chart} from "chart.js";

import {CardChartSource} from "./card-menu.types";

/**
 * Adapts a chart.js instance to a {@link CardChartSource} for the card menu's Copy/Save-image items.
 * `getChart` is a late-bound getter (the component's chart field is created in a lifecycle hook and
 * recreated on data change), so encoding always uses the currently rendered chart — and runs only
 * when the user clicks a menu item, never at render.
 */
export const chartImageSource = (getChart: () => Chart | undefined): CardChartSource => ({
    getImagePng: () => getChart()?.toBase64Image("image/png") ?? null,
    getImageBlob: () => {
        const canvas = getChart()?.canvas;
        if (!canvas) {
            return Promise.resolve(null);
        }
        return new Promise<Blob | null>((resolve) => canvas.toBlob((blob) => resolve(blob), "image/png"));
    },
});
